<template>
  <div
    class="message__block">
    <hcc-audio
      :src="fullUrl"
      :ext="extension"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import HccAudio from '@/components/shared/HccAudio/index.vue';

export default {
  components: {
    HccAudio,
  },
  props: {
    message: {
      required: true,
      type: Object,
    },
  },
  computed: {
    ...mapState(['token']),
    tokenQuery() {
      return `?token=${this.token}`;
    },
    multimedia() {
      return this.message.multimedia ?? {};
    },
    fullUrl() {
      return this.multimedia.file ? `${this.multimedia.file}${this.tokenQuery}` : '';
    },
    extension() {
      return this.multimedia.ext ?? '';
    },
    size() {
      return Number.parseInt(this.multimedia.size ?? 0, 10);
    },
  },
};
</script>
